<template src="./Position.html"></template>

<script>
import topMenu from '@/components/brand/components/topMenu';
import brandSelect from '@/components/components/BrandSelect';
import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/position')

export default {
  name: "brandCountry",
  components: {
    topMenu,
    brandSelect
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: false,
      fieldsList: [
        {
          key: 'site',
          label: 'Сайт',
          sortable: false
        },
        {
          key: 'queryText',
          label: 'Запросы',
          sortable: false
        },
        {
          key: 'frequency',
          label: 'Общая частота',
          sortable: true
        },
      ],
      searchEngine: 'google',
      searchEngOptions: [
        {
          text: 'Google',
          value: 'google',
        },
        {
          text: 'Yandex',
          value: 'yandex',
        },
      ],
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'UPDATE_POSITION',
    ]),
    brandsChange: function (brand) {
      if (
          brand == null
          || (
              this.CURRENT_BRAND != null
              && (
                  this.CURRENT_BRAND.id == brand.id
                  || (brand[0] != undefined && this.CURRENT_BRAND.id == brand[0].id)
              )
          )
      ) {
        return
      }
      this.brandId = brand.saleId.toString()
      this.$store.commit('brand/position/CURRENT_BRAND', brand);
      this.GET_DATA({id: this.brandId, th: this});
      this.$router.push({name: 'brandPosition', params: { id: brand.saleId }});
    },
    searchChange: function () {
      this.$store.commit('brand/position/SEARCH_ENGINE', this.searchEngine);
      this.GET_DATA({id: this.brandId, th: this});
    },
    positionUpdate() {
      this.UPDATE_POSITION({id: this.brandId, th: this})
    }
  },
  computed: {
    ...mapGetters([
      'DATA_BY_COUNTRY',
      'CURRENT_BRAND',
      'REGIONS',
      'COLUMN_HEADER',
    ]),
    getDataByRegion: function () {
      if (this.DATA_BY_COUNTRY.length === 0) {
        return []
      }
      let rowTemplate = {
        site: '_',
        queryText: '_',
        frequency: '_',
      }
      for (let key in this.COLUMN_HEADER) {
        rowTemplate[key] = '_'
      }

      let buf = []
      for (let key in this.REGIONS) {
        let regionName = this.REGIONS[key]
        let rowBuf = JSON.parse(JSON.stringify(rowTemplate))
        // push empty row between regions
        buf.push(rowBuf)
        // push region name
        rowBuf = JSON.parse(JSON.stringify(rowTemplate))
        rowBuf.site = regionName
        buf.push(rowBuf)
        // fill of date
        for (let key3 in this.DATA_BY_COUNTRY[regionName]) {
          buf.push(this.DATA_BY_COUNTRY[regionName][key3])
        }
      }

      return buf
    },
    getFieldsKey: function () {
      let fieldsList = []
      for (let key in this.COLUMN_HEADER) {
        fieldsList.push(key)
      }

      return fieldsList
    },
    getFieldsList: function () {
      let fieldsList = JSON.parse(JSON.stringify(this.fieldsList))
      for (let key in this.COLUMN_HEADER) {
        fieldsList.push(
            {
              key: key,
              label: this.COLUMN_HEADER[key],
              sortable: false
            },
        )
      }

      return fieldsList
    }
  },
  watch: {
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.initPageSize();
  },
  created() {
    if (
        this.DATA_BY_COUNTRY.length == 0
        || this.CURRENT_BRAND == null
        || this.CURRENT_BRAND.id != this.brandId
    ) {
      this.GET_DATA({id: this.brandId, th: this});
    }
  }
}
</script>

<style scoped>
.region-row {
  font-weight: bold;
}
.text-align-right {
  text-align: right;
}
</style>

<style>

</style>